var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewHotelProfileBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 35,
    viewBox: "0 0 44 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8018 34.4476C25.7236 34.3771 25.6566 34.2837 25.6056 34.173C25.5367 34.0234 25.5 33.8488 25.5 33.6703C25.5019 31.2251 26.1914 28.8809 27.4172 27.1519C28.4739 25.6613 29.8549 24.7329 31.3263 24.5035C29.6103 23.2115 28.5 20.7978 28.5 18.5653C28.5 16.9428 29.0795 15.3867 30.1109 14.2394C31.1424 13.0922 32.5413 12.4476 34 12.4476C34.1736 12.4476 34.3463 12.4568 34.5177 12.4748C34.2638 12.0058 33.9157 11.5866 33.4875 11.2465L20.4177 0.867558C18.9934 -0.263537 16.9852 -0.291294 15.5302 0.800001L1.6 11.2476C0.592777 12.003 0 13.1886 0 14.4476V30.4476C0 32.6568 1.79086 34.4476 4 34.4476H8.75L12.5 34.4476V21.4476C12.5 19.2385 14.2909 17.4476 16.5 17.4476H18.5C20.7091 17.4476 22.5 19.2385 22.5 21.4476V34.4476L25.8018 34.4476Z",
    fill: "#5F1CCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6206 34.5682C32.9775 34.6378 30.346 34.1954 27.871 33.2652C27.7606 33.2161 27.6668 33.1361 27.6009 33.0347C27.535 32.9334 27.5 32.8151 27.5 32.6942C27.5018 31.0381 28.1605 29.4503 29.3316 28.2792C30.5027 27.1082 32.0905 26.4495 33.7466 26.4476H37.4946C39.1507 26.4495 40.7385 27.1082 41.9096 28.2792C43.0807 29.4503 43.7394 31.0381 43.7412 32.6942C43.7412 32.8151 43.7062 32.9334 43.6403 33.0347C43.5744 33.1361 43.4806 33.2161 43.3701 33.2652C40.8952 34.1954 38.2636 34.6378 35.6206 34.5682V34.5682Z",
    fill: "#5F1CCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4973 24.0669C32.637 24.0669 30.5 21.0991 30.5 18.4449C30.5 17.1196 31.0265 15.8485 31.9637 14.9113C32.9008 13.9741 34.1719 13.4476 35.4973 13.4476C36.8227 13.4476 38.0937 13.9741 39.0309 14.9113C39.9681 15.8485 40.4946 17.1196 40.4946 18.4449C40.4946 21.0991 38.3576 24.0669 35.4973 24.0669Z",
    fill: "#5F1CCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4.44763L4.5 12.4476",
    stroke: "#5F1CCC",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewHotelProfileBlue);
export default __webpack_public_path__ + "static/media/New_Hotel_Profile_blue.2e9de558ffd8f173ecac2a1187f2aac0.svg";
export { ForwardRef as ReactComponent };